import { render, staticRenderFns } from "./WrongBook.vue?vue&type=template&id=7982e283&scoped=true&"
import script from "./WrongBook.vue?vue&type=script&lang=js&"
export * from "./WrongBook.vue?vue&type=script&lang=js&"
import style0 from "./WrongBook.vue?vue&type=style&index=0&id=7982e283&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982e283",
  null
  
)

export default component.exports